import { render } from "./SnailMail.vue?vue&type=template&id=578fb921&scoped=true"
const script = {}

import "./SnailMail.vue?vue&type=style&index=0&id=578fb921&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-578fb921"]])

export default __exports__